import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Alert } from '@zillow/constellation';
import {
  getAreCriminalReportsUnderManualReviewSelector,
  getAreEvictionReportsUnderManualReviewSelector,
} from '../../../../../../../selectors/sharedReports';

export const MANUAL_REVIEW_TEXT = `is under manual review due to regulatory requirements. The report should automatically refresh in 1 to 2 business days.`;

function BackgroundCheckManualReviewAlert({ applicant }) {
  const { userId: applicantId } = applicant;
  const areCriminalReportsUnderManualReview = useSelector(getAreCriminalReportsUnderManualReviewSelector(applicantId));
  const areEvictionReportsUnderManualReview = useSelector(getAreEvictionReportsUnderManualReviewSelector(applicantId));

  let body = null;

  // Both sections are under manual review.
  if (areCriminalReportsUnderManualReview && areEvictionReportsUnderManualReview) {
    body = `Background report ${MANUAL_REVIEW_TEXT}`;
    // Only one section is under manual review.
  } else if (areCriminalReportsUnderManualReview || areEvictionReportsUnderManualReview) {
    const recordName = areCriminalReportsUnderManualReview ? 'Criminal' : 'Housing court';
    body = `${recordName} report ${MANUAL_REVIEW_TEXT}`;
  }

  return body && <Alert appearance="warning" body={body} />;
}

BackgroundCheckManualReviewAlert.propTypes = {
  applicant: PropTypes.shape({
    userId: PropTypes.string.isRequired,
  }).isRequired,
};

export default BackgroundCheckManualReviewAlert;
